import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-estate-map',
    templateUrl: './estate-map.component.html',
    styleUrl: './estate-map.component.scss',
    imports: [
        RouterModule
    ]
})
export class EstateMapComponent {

}
